<script setup lang="ts">
const props = defineProps<{
    items: Record<string, any>[],
    title: string,
    fullButton: boolean,
    onlyOnlineBtn: boolean,
    shoppingSrc: string,
    compareData?: object,
    compareText: string,
    submitOrderBtnText: string,
    id: string,
}>();
const isModalShow = ref(false);
</script>

<template>
  <section id="sms_price" class="gridClass mt-16 mb-8">
    <h2 class="w-full mb-3">بسته‌های پنل پیامکی نواتل</h2>
    <div class="relative">
      <h3 class="text-center mb-10 lg:mb-14">
        {{ props.title }}
      </h3>
      <div class="grid grid-cols-1 tablet:grid-cols-2 laptop-m:flex gap-14 lg:gap-6 justify-center">
        <div
          class="w-[90%] mx-auto laptop-m:w-[96%] p-4 custom-shadow relative rounded-xl"
          v-for="item in props.items"
          :key="item.id"
        >
            <ProductSmsPlanCard 
                :item="item" 
                shoppingSrc="/online-shopping/buy/"
            />
        </div>
      </div>
    </div>
    <SectionModalCompare
      :isShow="isModalShow"
      @close="isModalShow = false"
      :data="props.compareData"
      :id="props.id"
    />
  </section>
</template>
